import type { useAnalyticsEvents } from '@atlaskit/analytics-next';

/**
 * Shared analytics action-subject for the recommend-work-email nudge
 * (`spark_recommend_work_email_signup`). Kept as a single constant so the
 * `shown` and `emailChanged` events stay consistent and are easy to query.
 */
export const RECOMMEND_WORK_EMAIL_NUDGE_SUBJECT = 'recommendWorkEmailNudge';

type CreateAnalyticsEvent = ReturnType<typeof useAnalyticsEvents>['createAnalyticsEvent'];

/**
 * Fires the `recommendWorkEmailNudge emailChanged` track event.
 *
 * Emitted once, when a user who was shown the nudge subsequently changes their
 * email from a personal domain to a business (non-personal) domain. This is the
 * direct signal for "how many users switched to a work email after the nudge"
 * and is the primary conversion metric for the experiment's treatment arm.
 */
export const fireNudgeEmailChangedAnalytics = ({
	createAnalyticsEvent,
}: {
	createAnalyticsEvent: CreateAnalyticsEvent;
}) => {
	createAnalyticsEvent({
		eventType: 'track',
		actionSubject: RECOMMEND_WORK_EMAIL_NUDGE_SUBJECT,
		action: 'emailChanged',
		attributes: {
			fromDomainType: 'personal-domain',
			toDomainType: 'business-domain',
		},
	}).fire();
};
